<div class="extra-narrow-content">
  <mat-card *ngIf="!submitSuccess">
    <mat-card-content>
      <h1>Change password</h1>
      <p>Enter your new password.</p>
      <form [formGroup]="form" (ngSubmit)="submit(form.value)">
        <div class="form-group">
          <mat-form-field class="simple-form-field-100">
            <mat-label>New password</mat-label>
            <input
              type="password"
              matInput
              placeholder="New password"
              name="password"
              formControlName="password"
              autocomplete="new-password"
            />
            <mat-error>{{ passwordErrorMessage }}</mat-error>
          </mat-form-field>
          <mat-progress-bar
            [color]="updatePasswordProgressColor(passwordGuessesLog10)"
            mode="determinate"
            value="{{ passwordProgressBarValue.toString() }}"
          ></mat-progress-bar>
          <br />
          <div class="button-right-container">
            <div></div>
            <div>
              <div class="spinner-container" *ngIf="waiting">
                <mat-spinner diameter="24"></mat-spinner>
              </div>
              <button
                mat-raised-button
                color="primary"
                [disabled]="waiting"
                type="submit"
                value="submit"
              >
                Change password
              </button>
            </div>
          </div>
          <span *ngIf="formErrorMessage" class="text-error-color">
            {{ formErrorMessage }}
          </span>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="submitSuccess" c>
    <mat-card-content>
      <h1>Change password</h1>
      <p>Your password has been updated.</p>
      <a routerLink="/" class="text-link"> Go to the home page. </a>
    </mat-card-content>
  </mat-card>
</div>
